import React from "react";
import styles from "./styles.module.css";
import { ButtonProps } from "../types";
import uncheckedBoxImgSrc from "../../../assets/39-box-m.svg";
import checkedBoxImgSrc from "../../../assets/38-check-box-m.svg";
import { TextCaption } from "fonts/Caption";
import { Spacing } from "spacing/component";
import { classNames } from "helpers/string";

interface Props extends ButtonProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export const CheckBox = ({
  text,
  checked = false,
  disabled,
  onChange
}: Props) => (
  <button
    type="button"
    className={classNames(styles)}
    onClick={onChange && (() => onChange(!checked))}
    {...{ disabled }}
  >
    <img src={checked ? checkedBoxImgSrc : uncheckedBoxImgSrc} />
    <Spacing pl="3xs" />
    <TextCaption>{text}</TextCaption>
  </button>
);
